import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import {
  Badge,
  Form,
  Row,
  Col,
  Container,
  Image,
  Button,
  Modal,
  Spinner,
  ModalBody,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getItem, showErrorToast } from "../../utils/Functions";
import { useHistory, useLocation } from "react-router-dom";
import { applyJob, getJobDetails, jobListing } from "../JobOpenings/action";
import { paths } from "../../router/Constant";
import MasterLayout from "../../components/Layout/MasterLayout";
import { offeredCandidateProfile } from "../Profile/actions";
import ACTION from "../../actions";

const JobDetails = () => {
  const [interested, setInterested] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [jobSuccess, setJobSuccess] = useState(false);
  const history = useHistory();
  const [showPreview, setShowPreview] = useState(false);
  const userInfo = JSON.parse(getItem("User") || "null");
  const type = getItem("type");
  const location = useLocation();

  const [ableToApply, setAbleToApply] = useState(true);
  const [preview, setPreview] = useState();
  const qualification = getItem("qualification") ?? "";
  const offeredCandidateReduxData = useSelector(
    (state) => state.profile.OfferedCandidateProfileDetails
  );

  const jobId = location?.state?.id
    ? location?.state?.id
    : location?.pathname.replace("/job-details/", "");

  const dispatch = useDispatch();

  const jobDetailsFromStore =
    useSelector((state) => state.jobOpening.jobDetails) ?? {};
  const jobsListings = useSelector(
    (state) => state.jobOpening.jobsListings
  );
  const jobFromListing = jobsListings?.webFormJobOpenings?.find(
    (job) => String(job?._id) === String(jobId)
  );
  const jobData = jobDetailsFromStore?._id
    ? jobDetailsFromStore
    : jobFromListing || location?.state?.job || {};

  useEffect(() => {
    dispatch(jobListing());
  }, []);

  useEffect(() => {
    if (location?.state?.job) {
      dispatch({
        type: ACTION.JOB_DETAILS,
        payload: location.state.job,
      });
    }
  }, [location?.state?.job]);

  useEffect(() => {
    if (jobId) {
      dispatch(getJobDetails({ jobId }));
    }
  }, [jobId]);

  useEffect(() => {
    if (userInfo?._id) {
      dispatch(offeredCandidateProfile(userInfo._id));
    }
  }, [userInfo?._id]);

  const handleApply = async () => {
    setIsLoading(true);

    if (type === "candidate") {
      const { basicInfo, professionalDetails, addressDetails, resume } =
        offeredCandidateReduxData;
      const { firstName, lastName, mobile, email, noticePeriod } = basicInfo;
      const { currentEmployer, totalExprience, currentSalary, skillSet } =
        professionalDetails;
      const { city, country } = addressDetails;

      if (
        !firstName ||
        !lastName ||
        !mobile ||
        !email ||
        //!gender ||
        //!jobLocation ||
        !noticePeriod ||
        !qualification ||
        //qualification === undefined ||
        skillSet.length === 0 ||
        !currentEmployer ||
        //hasEmptyValue ||
        !currentSalary ||
        //!expectedSalary ||
        // !currentDesignation ||
        !city ||
        !country
      ) {
        showErrorToast("Please update your profile with all required fields.");
        // } else if (!resume) {
        //   showErrorToast("Please upload your resume.");
      } else {
        const payload = {
          _id: userInfo._id,
          firstName,
          lastName,
          mobile,
          phoneCode: basicInfo.phoneCode || "91",
          emailId: email,
          currentEmployer,
          totalExperiance: totalExprience,
          currentSalary,
          qualification,
          city,
          resume,
          postingTitle: jobData?._id,
          createdFrom: "webForm",
        };

        await dispatch(applyJob(payload));
        history.push(paths.jobOpenings);
      }
    } else {
      history.push(paths.addProfile, { job: jobData });
    }
    setIsLoading(false);
  };

  return (
    <MasterLayout minimalHeader>
      <div className="main-img-bg jd-page">
        <Container>
          <div className="home-banner-wrap-section pt-0 jd-hero-section">
            <div>
              <h4 className="text-primary mb-0">Apply for</h4>
              <h1 className="text-dark display-4 font-weight-semibold mb-0">
                {jobData && jobData.title}
              </h1>
            </div>
          </div>
          <header
            className="consultant-header d-block"
          // style={{ backgroundImage: `url(${bgImg})` }}
          ></header>
          <div className="jd-body-panel">
            {!interested && (
              <React.Fragment>
                <Row>
                  <Col md="9">
                    <div className="panel">
                      <div className="panel-content pb-0">
                        <h3 className="title text-gray mb-2">
                          Job Description
                        </h3>
                        <section
                          className="job-description-content"
                          dangerouslySetInnerHTML={{
                            __html: jobData && jobData.description,
                          }}
                        />
                      </div>
                      <hr />
                      <div className="jdp-jobdescription panel-content pt-0">
                        <h3 className="title text-gray mb-3">About us</h3>
                        <h4 className="sub-title">About IndiaNIC</h4>
                        <p>
                          With a talented team of 550+ engineers, project
                          managers and leaders, we excel in providing top-notch
                          award winning solutions. Seeing the clients passionate
                          about their idea makes us excited. We always look for
                          new ways to provide solutions and create a better
                          product.
                        </p>

                        <p className="mb-2 text-primary">We work on - </p>

                        <h4 className="sub-title">WEB DEVELOPMENT</h4>
                        <p>
                          We’ve been working with robust and popular web
                          technologies for just about two decades, and it’s
                          something we still love doing today. Whether creating
                          a web presence for your company, an information hub
                          for your business or empowering your apps / IoT
                          devices through backend or an Online Shopping – we
                          cover a wide spectrum of solutions and frameworks by
                          leveraging the power of theinternet.
                        </p>

                        <h4 className="sub-title">MOBILE APPS</h4>
                        <p>
                          From B2B or B2E apps for enterprises, small
                          businesses, and startups, we have a proven track
                          record of creating high-impact, result driven and
                          engaging mobile apps on all popular platforms with
                          Native, Cross-Platform, and Hybrid Technologies.
                        </p>

                        <h4 className="sub-title">UI / UX</h4>
                        <p>
                          Just as the designs themselves, we love the process of
                          creating them as well. The innovative ideas need
                          greater innovation in the way their visual
                          representation is created.
                        </p>
                        <p>
                          We tend to lean more on function over the form. We
                          believe in simplicity and focus. We know the fine
                          differentiator between the visually appealing versus
                          the functional design. We help you craft niche
                          experiences for Web and Mobile via designing
                          Information Architecture, Wireframes, Prototypes and
                          Visual Design.
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col md="3">
                    <div className="side-panel">
                      <div className="panel">
                        <div className="panel-content">
                          <h3 className="title text-gray mb-3">Requirements</h3>
                          <h4 className="sub-title">Work Experience</h4>
                          <p className="text-gray">
                            {jobData &&
                              jobData.workExperience_min +
                              "-" +
                              jobData.workExperience_max}{" "}
                            years
                          </p>

                          <h4 className="sub-title">Job Type</h4>
                          <p className="text-gray">{jobData && jobData.jobType}</p>

                          <h4 className="sub-title">Posted on</h4>
                          <p className="text-gray">
                            {jobData &&
                              moment(jobData.publishedOn).format("DD MMM YYYY")}
                          </p>

                          {(() => {
                            const rawSkills = jobData?.skillSet;
                            const skills = Array.isArray(rawSkills?.[0])
                              ? rawSkills[0]
                              : rawSkills;
                            if (!Array.isArray(skills) || skills.length === 0) {
                              return null;
                            }
                            return (
                              <>
                                <h4 className="sub-title">Skills</h4>
                                {skills.map((item, index) => {
                                  const label =
                                    typeof item === "string"
                                      ? item
                                      : item?.skill || item?.label || item?.name || "";
                                  if (!label) return null;
                                  return (
                                    <Badge
                                      key={`${label}-${index}`}
                                      variant="dark"
                                      className="me-2 mb-1"
                                    >
                                      {label}
                                    </Badge>
                                  );
                                })}
                              </>
                            );
                          })()}
                        </div>
                      </div>
                      <Button
                        size="block"
                        variant="primary"
                        disabled={jobData?.isApplied}
                        onClick={() => {
                          handleApply();
                        }}
                        style={{ padding: "16px 0" }}
                        className="w-100 justify-content-center"
                      >
                        {jobData?.isApplied ? "Applied!" : "Apply Here"}
                      </Button>
                      {/* <Button type="clear" variant="light" size="block" className="mt-3 py-3">Cancel</Button> */}
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </div>

          <div className="jd-body-panel">
            {interested && !jobSuccess && (
              <section className="consultant-add-form">
                <Row></Row>
              </section>
            )}
          </div>
        </Container>
      </div>

      <Modal show={showPreview} size="lg" onHide={() => setShowPreview(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body> {preview && <iframe src={preview} />}</Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setShowPreview(false)}>OK</Button>
        </Modal.Footer>
      </Modal>
    </MasterLayout>
  );
};

export default JobDetails;
